import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { january2026Data } from './january2026Data';
import { february2026Data } from './february2026Data';
import { march2026Data } from './march2026Data';

// Q1 2026 Standard Report - aggregates January, February, and March 2026
const allMonthlyReports = [
  january2026Data,
  february2026Data,
  march2026Data
];

const combinedData = combineReports(allMonthlyReports, 'Q1 2026 Standard Report');

export const q1_2026Data: ReportData = {
  ...combinedData,
  period: {
    month: 1,
    year: 2026,
    quarter: 1,
    startMonth: 1,
    endMonth: 3
  }
};
